'use client';

import createTheme from "./createTheme.js";
const defaultTheme = createTheme();
export default defaultTheme;